module.exports = __webpack_public_path__ + "img/icon_yczs.22576e6a.png";